import classNames from 'classnames';

import { iconSize } from '../components/hooks/icon.css';
import {
  largeCorrection,
  mediumCorrection,
  smallCorrection,
  xsmallCorrection,
} from '../components/Icons/icon.css';
import type { IconProps } from '../components/Icons/types';
import { tone as textTone } from '../css/typography.css';

const verticalAlignmentCorrection = {
  xsmall: xsmallCorrection,
  small: smallCorrection,
  medium: mediumCorrection,
  large: largeCorrection,
  large25: largeCorrection,
};

export const useIcon = ({ size, tone }: IconProps): { className: string } => {
  return {
    className: classNames(
      verticalAlignmentCorrection[size || 'medium'],
      iconSize[size || 'medium'],
      tone ? textTone[tone] : '',
    ),
  };
};
